import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import axios from 'axios';
import CONFIG from "../../config";

import { useNavigate } from "./router";
import { pageActions, basketActions, configActions } from "../../actions";

class BeendenButton extends Component {
  constructor(props) {
    super(props);
    this.exitApp = this.exitApp.bind(this);
    this.state = { error: null };
  }

  exitApp() {
    this.setState({ error: null });
    let requestData = this.props.configStorage.getRequestData("exitApp", "post");
    let header = this.props.configStorage.getRequestHeader();

    // TODO: Remove patch after analysis of wrong appId for edelmetallkunde
    if (CONFIG.isVerseNeo()) {
      if (window.location.pathname.match("/edelmetallKunde/")) {
        header.applikationId="VNeoEmWlBuy";        
      } else if (window.location.pathname.match("/sortenKunde/")) {
        header.applikationId="VNeoSoWlBuy";        
      }
    }

    let config = {
      headers: {
        request: JSON.stringify(header)
      }
    };
    const data = { exitStatus: "SUCCESS" };
    let axiosVerify = axios.create(config);
    axiosVerify[requestData.request.type](requestData.url, { ...data, header: { ...header }, })
      .then(response => {
        if (response && response.status < 400) {
          this.props.dispatch(configActions.setRenderLandingPage(true));
          this.props.dispatch(pageActions.setOverviewPage());
          this.props.dispatch(basketActions.resetWarenkorb());
          window.OSPlusNeo.reportSuccess();
        } else {
          console.error("x1");
          this.setState({ error: "Beim Abmelden ist ein Fehler aufgetreten!" });
        }
      })
      .catch((error) => {
        console.error("x2", error);
        this.setState({ error: "Beim Abmelden ist ein Fehler aufgetreten!" });
      });
  }

  render() {
    const OSPlusNeo = window.OSPlusNeo;
    let { configStorage } = this.props || {};
    if (!configStorage.isVerseNeo() || !OSPlusNeo) return null;
    const className = this.props.className || "";
    const variant = this.props.variant || "secondary";
    return <>
      <Button variant={variant} className={className} onClick={this.exitApp}>Anwendung beenden</Button>
      {this.state.error
        ? <div className="alert alert-danger">{this.state.error}</div>
        : null
      }
    </>;
  }
}

export default connect(store => {
  return {
    configStorage: store.configStorage,
  };
})((props) => {
  const navigate = useNavigate();
  const contextNavigate = props.configStorage.contextNavigate(navigate);
  return <BeendenButton navigate={contextNavigate} {...props} />;
});
